import { render, staticRenderFns } from "./ManagerCampsRegistryScrollFixTable.vue?vue&type=template&id=79ef70c6&lang=pug&"
import script from "./ManagerCampsRegistryScrollFixTable.vue?vue&type=script&lang=js&"
export * from "./ManagerCampsRegistryScrollFixTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports